import { render } from "./BookingDetailsPage.vue?vue&type=template&id=91456160&scoped=true"
import script from "./BookingDetailsPage.vue?vue&type=script&lang=js"
export * from "./BookingDetailsPage.vue?vue&type=script&lang=js"

import "./BookingDetailsPage.vue?vue&type=style&index=0&id=91456160&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91456160"]])

export default __exports__